/**
 * Types for Agent Ingress functionality
 * Ingress buttons open the AI Assistant, create a new session, and send an initial message
 */

export enum AgentIngressPromptType {
  PATIENT_SUMMARY = 'PATIENT_SUMMARY',
  COMMUNICATION_HISTORY = 'COMMUNICATION_HISTORY',
  MEDICAL_HISTORY = 'MEDICAL_HISTORY',
  OVERDUE_ITEMS = 'OVERDUE_ITEMS',
}

export type IngressContextKey = 'patientId' | 'clientId'

export interface AgentIngressOptions {
  clientId?: string
  patientId?: string
}
